import { mapValuesAsync } from '@exodus/basic-utils';
import assert from 'minimalistic-assert';
export default function transformStorage({ storage, onRead, onWrite, }) {
    assert(storage, 'missing storage');
    assert(onRead || onWrite, 'one of onRead, onWrite has to be specified');
    const _transformOnRead = onRead ?? ((value) => value);
    const _transformOnWrite = onWrite ?? ((value) => value);
    const transformOnRead = async (value, key) => {
        try {
            return await _transformOnRead(value, key);
        }
        catch (err) {
            throw new Error(`Failed to transform read value for key "${key}"`, { cause: err });
        }
    };
    const transformOnWrite = async (value, key) => {
        try {
            return await _transformOnWrite(value, key);
        }
        catch (err) {
            throw new Error(`Failed to transform write value for key "${key}"`, { cause: err });
        }
    };
    return {
        ...storage,
        namespace: (prefix) => transformStorage({
            storage: storage.namespace(prefix),
            onWrite: transformOnWrite,
            onRead: transformOnRead,
        }),
        set: async (key, value) => storage.set(key, (await transformOnWrite(value, key))),
        batchSet: async (obj) => storage.batchSet((await mapValuesAsync(obj, transformOnWrite))),
        get: async (key) => transformOnRead(await storage.get(key), key),
        batchGet: async (keys) => {
            const values = await storage.batchGet(keys);
            return Promise.all(values.map((value, i) => transformOnRead(value, keys[i])));
        },
    };
}
